var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio",attrs:{"id":"Inicio"}},[_c('MenuMovilTP'),_vm._v(" "),_c('MenuMovilUni')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0114b46c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-carousel-slide":"img-src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Inicio.vue
// module id = EbxX
// module chunks = 1